import { KeyboardEventHandler, ReactNode } from "react";
import styles from "./ListableTaskCardWrapper.module.css";

type ListableTaskCardProps = {
  children: ReactNode;
  onSelect?: () => void | undefined;
  "aria-label"?: string | undefined;
};

function ListableTaskCardWrapper({
  children,
  onSelect,
  "aria-label": ariaLabel,
}: ListableTaskCardProps) {
  const className = onSelect ? styles["clickable"] : styles["nonClickable"];

  const handleKeyDown: KeyboardEventHandler<HTMLLIElement> = (event) => {
    if (onSelect && (event.key === " " || event.key === "Enter")) {
      event.preventDefault();
      onSelect();
    }
  };

  return (
    <li
      className={className}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
      role="listitem"
      aria-label={ariaLabel}
      tabIndex={0}
    >
      {children}
    </li>
  );
}

export default ListableTaskCardWrapper;
